<script setup lang="ts">
  import type { IUser } from '~/types'

  defineProps<{
    currentUser: IUser | null
    items: {
      id: string
      value: string
      label: string
    }[]
  }>()

  const { t } = useI18n()
</script>

<template>
  <div class="flex w-full flex-col justify-start gap-2">
    <div class="border-primary flex flex-col border-b-1">
      <span class="text-sm">{{
        t('pages.me.update-user-data.name-title')
      }}</span>

      <span> {{ currentUser?.info.name }}</span>
    </div>

    <div class="border-primary flex flex-col border-b-1">
      <span class="text-sm">{{
        t('pages.me.update-user-data.middlename-title')
      }}</span>

      <span> {{ currentUser?.info.middlename }}</span>
    </div>

    <div class="border-primary flex flex-col border-b-1">
      <span class="text-sm">{{
        t('pages.me.update-user-data.surname-title')
      }}</span>

      <span> {{ currentUser?.info.surname }}</span>
    </div>

    <div class="border-primary flex flex-col border-b-1">
      <span class="text-sm">{{
        t('pages.me.update-user-data.phone-title')
      }}</span>

      <span> {{ formatPhoneByCountry(currentUser!.info.phone || '') }}</span>
    </div>

    <div class="flex flex-col gap-1">
      <span class="text-sm">{{ t('pages.me.contact-information.title') }}</span>

      <div
        v-for="contact in currentUser?.contacts"
        :key="contact.contact_type_id"
      >
        <span class="border-primary ml-2 flex w-full border-b-1 text-sm">
          {{ items.find((i) => i.id === contact.contact_type_id)?.label }}:
          {{
            ['phone', 'whatsapp'].includes(
              items.find((i) => i.id === contact.contact_type_id)?.value ?? ''
            )
              ? formatPhoneByCountry(contact.value)
              : contact.value
          }}</span
        >
      </div>
    </div>
  </div>
</template>
